var customCodFormProvinces = {
        data: {
  "Amazonas": {
    "Bagua": {
      "Bagua": true
    },
    "Chachapoyas": {
      "Chachapoyas": true
    },
    "Luya": {
      "Luya": true
    },
    "Utcubamba": {
      "Bagua Grande": true
    }
  },
  "Áncash": {
    "Carhuaz": {
      "Acopampa": true,
      "Anta": true,
      "Carhuaz": true,
      "Marcara": true
    },
    "Casma": {
      "Casma": true
    },
    "Huaraz": {
      "Huaraz": true,
      "Independencia": true,
      "Jangas": true,
      "Tarica": true
    },
    "Huarmey": {
      "Huarmey": true
    },
    "Huaylas": {
      "Caraz": true,
      "Pueblo Libre": true
    },
    "Santa": {
      "Chimbote": true,
      "Nuevo Chimbote": true
    },
    "Yungay": {
      "Mancos": true,
      "Ranrahirca": true,
      "Yungay": true
    }
  },
  "Apurímac": {
    "Abancay": {
      "Abancay": true
    },
    "Andahuaylas": {
      "Andahuaylas": true,
      "Talavera": true
    }
  },
  "Arequipa": {
    "Arequipa": {
      "Alto Selva Alegre": true,
      "Arequipa": true,
      "Cayma": true,
      "Cerro Colorado": true,
      "Characato": true,
      "Jacobo Hunter": true,
      "Jose Luis Bustamante Y Rivero": true,
      "La Joya": true,
      "Mariano Melgar": true,
      "Miraflores": true,
      "Paucarpata": true,
      "Socabaya": true,
      "Tiabaya": true,
      "Uchumayo": true,
      "Yanahuara": true
    },
    "Camana": {
      "Camana": true,
      "Samuel Pastor": true
    },
    "Caraveli": {
      "Chala": true
    },
    "Caylloma": {
      "Majes": true
    },
    "Islay": {
      "Dean Valdivia": true,
      "Mollendo": true
    }
  },
  "Ayacucho": {
    "Huamanga": {
      "Andres Avelino Caceres Dorregaray": true,
      "Ayacucho": true,
      "Carmen Alto": true,
      "Jesus Nazareno": true,
      "San Juan Bautista": true
    },
    "Huanta": {
      "Huanta": true
    }
  },
  "Cajamarca": {
    "Bambamarca": {
      "Bambamarca": true
    },
    "Cajabamba": {
      "Cajabamba": true
    },
    "Cajamarca": {
      "Cajamarca": true,
      "Los Baños Del Inca": true
    },
    "Celendin": {
      "Celendin": true
    },
    "Chota": {
      "Chota": true
    },
    "Contumaza": {
      "Chilete": true
    },
    "Cutervo": {
      "Cutervo": true
    },
    "Hualgayoc": {
      "Bambamarca": true
    },
    "Jaen": {
      "Bellavista": true,
      "Jaen": true,
      "Santa Rosa": true
    },
    "San Ignacio": {
      "San Ignacio": true
    },
    "San Marcos": {
      "Chancay": true
    }
  },
  "Callao": {
    "Callao": {
      "Bellavista": true,
      "Callao": true,
      "Carmen De La Legua Reynoso": true,
      "La Perla": true,
      "La Punta": true,
      "Mi Perú": true,
      "Ventanilla": true
    }
  },
  "Cuzco": {
    "Anta": {
      "Anta": true,
      "Zurite": true
    },
    "Calca": {
      "Calca": true
    },
    "Canchis": {
      "Combapata": true,
      "Sicuani": true
    },
    "Cusco": {
      "Ccorca": true,
      "Cusco": true,
      "Poroy": true,
      "Quillabamba": true,
      "San Jeronimo": true,
      "San Sebastian": true,
      "Santiago": true,
      "Saylla": true,
      "Wanchaq": true
    },
    "Espinar": {
      "Alto Pichigua": true,
      "Condoroma": true,
      "Coporaque": true,
      "Espinar": true,
      "Ocoruro": true,
      "Pallpata": true,
      "Pichigua": true,
      "Suyckutambo": true
    },
    "La Convencion": {
      "Santa Ana": true
    },
    "Quispicanchi": {
      "Urcos": true
    },
    "Urubamba": {
      "Chinchero": true,
      "Urubamba": true
    }
  },
  "Huancavelica": {
    "Huancavelica": {
      "Ascension": true,
      "Huancavelica": true
    }
  },
  "Huánuco": {
    "Ambo": {
      "Ambo": true
    },
    "Dos De Mayo": {
      "La Unión": true
    },
    "Huanuco": {
      "Amarilis": true,
      "Huanuco": true
    },
    "Leoncio Prado": {
      "Jose Crespo Y Castillo": true,
      "Luyando": true,
      "Rupa-Rupa": true
    }
  },
  "Ica": {
    "Chincha": {
      "Chincha Alta": true,
      "Pueblo Nuevo": true
    },
    "Ica": {
      "Ica": true,
      "La Tinguiña": true,
      "Los Aquijes": true,
      "Parcona": true,
      "Pueblo Nuevo": true,
      "Salas": true,
      "Santiago": true,
      "Subtanjalla": true
    },
    "Nazca": {
      "Marcona": true,
      "Nazca": true,
      "Vista Alegre": true
    },
    "Pisco": {
      "Huancano": true,
      "Humay": true,
      "Independencia": true,
      "Paracas": true,
      "Pisco": true,
      "San Andrés": true,
      "San Clemente": true,
      "Tupac Amaru Inca": true
    }
  },
  "Junín": {
    "Chanchamayo": {
      "Chanchamayo": true,
      "Perene": true,
      "Pichanaqui": true,
      "San Ramón": true
    },
    "Chupaca": {
      "Chupaca": true
    },
    "Concepcion": {
      "Aco": true,
      "Andamarca": true,
      "Chambara": true,
      "Cochas": true,
      "Comas": true,
      "Concepcion": true,
      "Heroinas Toledo": true,
      "Manzanares": true,
      "Mariscal Castilla": true,
      "Matahuasi": true,
      "Mito": true,
      "Nueve De Julio": true,
      "Orcotuna": true,
      "San Jose De Quero": true,
      "Santa Rosa De Ocopa": true
    },
    "Huancayo": {
      "Chilca": true,
      "El Tambo": true,
      "Hualhuas": true,
      "Huancan": true,
      "Huancayo": true,
      "Huayucachi": true,
      "Pilcomayo": true,
      "San Agustín": true
    },
    "Jauja": {
      "Jauja": true
    },
    "Satipo": {
      "Mazamari": true,
      "Pangoa": true,
      "Satipo": true
    },
    "Tarma": {
      "Acobamba": true,
      "La Unión": true,
      "Tarma": true
    },
    "Yauli": {
      "La Oroya": true
    }
  },
  "La Libertad": {
    "Ascope": {
      "Casa Grande": true,
      "Paijan": true
    },
    "Chepen": {
      "Chepen": true,
      "Pacanga": true
    },
    "Otuzco": {
      "Otuzco": true
    },
    "Pacasmayo": {
      "Guadalupe": true,
      "Pacasmayo": true
    },
    "Sanchez Carrion": {
      "Huamachuco": true
    },
    "Trujillo": {
      "El Porvenir": true,
      "Huanchaco": true,
      "La Esperanza": true,
      "Laredo": true,
      "Moche": true,
      "Trujillo": true,
      "Víctor Larco Herrera": true
    },
    "Viru": {
      "Chao": true,
      "Vir{u": true
    }
  },
  "Lambayeque": {
    "Chiclayo": {
      "Chiclayo": true,
      "Jose Leonardo Ortiz": true,
      "La Victoria": true,
      "Monsefu": true,
      "Pimentel": true,
      "Pucala": true
    },
    "Ferreñafe": {
      "Ferreñafe": true
    },
    "Lambayeque": {
      "Lambayeque": true,
      "Morrope": true,
      "Motupe": true,
      "Olmos": true,
      "Tucume": true
    }
  },
  "Lima (Departamento)": {
    "Barranca": {
      "Barranca": true,
      "Paramonga": true,
      "Pativilca": true,
      "Supe Puerto": true
    },
    "Cañete": {
      "Imperial": true,
      "Mala": true,
      "Nuevo Imperial": true,
      "Quilmana": true,
      "San Vicente De Cañete": true
    },
    "Huaral": {
      "Aucallama": true,
      "Chancay": true,
      "Huaral": true
    },
    "Huaura": {
      "Huacho": true,
      "Hualmay": true,
      "Huaura": true,
      "Santa María": true
    },
    "Lima": {
      "Ancón": true,
      "Ate": true,
      "Barranco": true,
      "Bellavista": true,
      "Breña": true,
      "Carabayllo": true,
      "Cercado de Lima": true,
      "Chaclacayo": true,
      "Chorrillos": true,
      "Cieneguilla": true,
      "Comas": true,
      "El Agustino": true,
      "Huachipa": true,
      "Independencia": true,
      "Jesús María": true,
      "La Molina": true,
      "La Perla": true,
      "La Victoria": true,
      "Lima": true,
      "Lince": true,
      "Los Olivos": true,
      "Lurigancho": true,
      "Lurín": true,
      "Magdalena Del Mar": true,
      "Miraflores": true,
      "Pachacamac": true,
      "Pucusana": true,
      "Pueblo Libre": true,
      "Puente Piedra": true,
      "Punta Hermosa": true,
      "Punta Negra": true,
      "Rímac": true,
      "San Bartolo": true,
      "San Borja": true,
      "San Isidro": true,
      "San Juan De Lurigancho": true,
      "San Juan De Miraflores": true,
      "San Luis": true,
      "San Martín de Porres": true,
      "San Miguel": true,
      "Santa Anita": true,
      "Santa Maria Del Mar": true,
      "Santa Rosa": true,
      "Santiago De Surco": true,
      "Surquillo": true,
      "Villa El Salvador": true,
      "Villa María del Triunfo": true
    }
  },
  "Loreto": {
    "Alto Amazonas": {
      "Yurimaguas": true
    },
    "Mariscal Ramon Castilla": {
      "Ramon Castilla": true
    },
    "Maynas": {
      "Belen": true,
      "Iquitos": true,
      "Punchana": true,
      "San Juan Bautista": true
    }
  },
  "Madre De Dios": {
    "Tambopata": {
      "Inambari": true,
      "Laberinto": true,
      "Tambopata": true
    }
  },
  "Moquegua": {
    "Ilo": {
      "Ilo": true,
      "Pacocha": true
    },
    "Mariscal Nieto": {
      "Moquegua": true,
      "Samegua": true
    }
  },
  "Pasco": {
    "Oxapampa": {
      "Oxapampa": true,
      "Pozuzo": true,
      "Villa Rica": true
    },
    "Pasco": {
      "Chaupimarca": true,
      "Huayllay": true,
      "Yanacancha": true
    }
  },
  "Piura": {
    "Ayabaca": {
      "Ayabaca": true,
      "Paimas": true
    },
    "Huancabamba": {
      "Huancabamba": true
    },
    "Morropon": {
      "Chulucanas": true,
      "Morropón": true
    },
    "Paita": {
      "Paita": true
    },
    "Piura": {
      "Castilla": true,
      "Catacaos": true,
      "La Unión": true,
      "Las Lomas": true,
      "Piura": true,
      "Tambo Grande": true,
      "Veintiseis De Octubre": true
    },
    "Sechura": {
      "Sechura": true
    },
    "Sullana": {
      "Bellavista": true,
      "Ignacio Escudero": true,
      "Sullana": true
    },
    "Talara": {
      "El Alto": true,
      "La Brea": true,
      "Los Organos": true,
      "Pariñas": true
    }
  },
  "Puno": {
    "Azangaro": {
      "Azangaro": true
    },
    "Chucuito": {
      "Desaguadero": true
    },
    "El Collao": {
      "Ilave": true
    },
    "Melgar": {
      "Ayaviri": true
    },
    "Puno": {
      "Puno": true
    },
    "San Roman": {
      "Juliaca": true,
      "San Miguel": true
    },
    "Yunguyo": {
      "Yunguyo": true
    }
  },
  "San Martín": {
    "Bellavista": {
      "Bellavista": true
    },
    "Lamas": {
      "Lamas": true
    },
    "Mariscal Caceres": {
      "Juanjui": true
    },
    "Moyobamba": {
      "Calzada": true,
      "Moyobamba": true,
      "Soritor": true
    },
    "Picota": {
      "Picota": true
    },
    "Rioja": {
      "Nueva Cajamarca": true,
      "Pardo Miguel": true,
      "Rioja": true
    },
    "San Martin": {
      "La Banda De Shilcayo": true,
      "Morales": true,
      "Tarapoto": true
    },
    "Tocache": {
      "Tocache": true,
      "Uchiza": true
    }
  },
  "Tacna": {
    "Tacna": {
      "Ciudad Nueva": true,
      "Coronel Gregorio AlbarracÍn Lanchipa": true,
      "Tacna": true
    }
  },
  "Tumbes": {
    "Contralmirante Villar": {
      "Canoas De Punta Sal": true,
      "Casitas": true,
      "Zorritos": true
    },
    "Tumbes": {
      "Corrales": true,
      "Tumbes": true
    },
    "Zarumilla": {
      "Aguas Verdes": true,
      "Zarumilla": true
    }
  },
  "Ucayali": {
    "Coronel Portillo": {
      "Callería": true,
      "Iparia": true,
      "Manantay": true,
      "Masisea": true,
      "Yarinacocha": true
    }
  }
},
startFields: function () {
            document.querySelector('#_rsi-cod-form-modal [data-type="province_country_field"]').addEventListener("change", customCodFormProvinces.onProvinceChange);
            document.querySelector('#_rsi-cod-form-modal [data-type="city_country_field"]').addEventListener("change", customCodFormProvinces.onCityChange);
        },
        onProvinceChange: function () {
            var value = document.querySelector('#_rsi-cod-form-modal [data-type="province_country_field"]').value;

            var html = "";

            if (!customCodFormProvinces.data[value]) {
                html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';
                document.querySelector('#_rsi-cod-form-modal [data-type="city_country_field"]').innerHTML = html;
                document.querySelector('#_rsi-cod-form-modal [data-type="city_country_field"]').value = "";
                customCodFormProvinces.onCityChange();
                return;
            }

            html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';

            Object.keys(customCodFormProvinces.data[value]).sort().forEach(function (item) {
                html += '<option value="' + item + '">' + item + '</option>';
            });

            document.querySelector('#_rsi-cod-form-modal [data-type="city_country_field"]').innerHTML = html;
            document.querySelector('#_rsi-cod-form-modal [data-type="city_country_field"]').value = "";
            customCodFormProvinces.onCityChange();
        },
        onCityChange: function () {
            var provValue = document.querySelector('#_rsi-cod-form-modal [data-type="province_country_field"]').value;
            var value = document.querySelector('#_rsi-cod-form-modal [data-type="city_country_field"]').value;

            var html = "";

            if (!customCodFormProvinces.data[provValue]) {
                html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
                document.querySelector('#_rsi-cod-form-modal [data-type="civic_number_country_field"]').innerHTML = html;
                document.querySelector('#_rsi-cod-form-modal [data-type="civic_number_country_field"]').value = "";
                return;
            }

            if (!customCodFormProvinces.data[provValue][value]) {
                html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
                document.querySelector('#_rsi-cod-form-modal [data-type="civic_number_country_field"]').innerHTML = html;
                document.querySelector('#_rsi-cod-form-modal [data-type="civic_number_country_field"]').value = "";
                return;
            }

            html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';

            Object.keys(customCodFormProvinces.data[provValue][value]).sort().forEach(function (item) {
                html += '<option value="' + item + '">' + item + '</option>';
            });

            document.querySelector('#_rsi-cod-form-modal [data-type="civic_number_country_field"]').innerHTML = html;
            document.querySelector('#_rsi-cod-form-modal [data-type="civic_number_country_field"]').value = "";
        }
    };

    function _COD_FORM_ON_OPEN_INIT_END_DEF() {
        customCodFormProvinces.startFields();
    }

    var _COD_FORM_CITY_LABEL = "";
    var _COD_FORM_ZIP_LABEL = "";

    function _COD_FORM_OVERWRITE_INIT() {

        _rsi.s.form.fields.items_array.forEach(function (item) {
            if (item.type == "province_country_field" || item.type == "province") {
                item.type = "province_country_field";
                item.backendFields.name = "province_country_field";
                item.backendFields.elementType = "select";
                var options = [];
                Object.keys(customCodFormProvinces.data).sort().forEach(function (i) {
                  options.push({
                      value: i, label: i
                  });
              });
                item.backendFields.options = options;
            } else if (item.type == "city") {
                item.type = "city_country_field";
                item.backendFields.name = "city";
                item.backendFields.elementType = "select";
                _COD_FORM_CITY_LABEL = item.n.ph;
                var options = [{
                    value: "", label: _COD_FORM_CITY_LABEL
                }];
                item.backendFields.options = options;
            } else if (item.type == "civic_number") {
                item.type = "civic_number_country_field";
                item.backendFields.name = "civic_number";
                item.backendFields.elementType = "select";
                _COD_FORM_ZIP_LABEL = item.n.ph;
                var options = [{
                    value: "", label: _COD_FORM_ZIP_LABEL
                }];
                item.backendFields.options = options;
            }
        });

        return true;
    }